export default __webpack_public_path__ + "static/media/now-not-yet.fbd9f259.jpg";